import { render, staticRenderFns } from "./NativeBridge.vue?vue&type=template&id=38a33759"
import script from "./NativeBridge.vue?vue&type=script&lang=js"
export * from "./NativeBridge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports